import * as service from './custom_tasks.service.js'
export default {
  data() {
    return {
      customTasks: [this.getIntializedCustomTask()],
    }
  },
  mounted() {
    let context = this
    this.GetAllLogCustomTasks()
  },
  methods: {


//FG - FOOF - After Cert - First Release Security
shouldNameBeDisabled(id, aName) {
  //The id will only be zero (the null is really not needed but...) 
  //then the task name being checked has to be from an add.
  //If the row was added then the person who added it should have the
  //opportunity to modify it before doing the update to the database
  //therefore any reading with an id of 0 will NOT be disabled.     
  if(id == null || id == 0) return false;
  //For rows with id > 1 we need to be sure the user is allowed to edit 
  //FG - FOOF - After Cert - First Release Security - custom readings controlled by "managetemplates" 
  //return !this.$hydrowareSecurityJS.canEdit_A('managecustomtasks');
  return !this.$hydrowareSecurityJS.canEdit_A('managetemplates');
},
//FG - FOOF - After Cert - First Release Security
shouldDeleteBeDisplayed(id, readingName) {
  //The id will only be zero (the null is really not needed but...) 
  //then the task name being checked has to be from an add.
  //If the row was added then the person who added it should have the
  //opportunity to removed it before doing the update to the database
  //therefore any reading with an id of 0 will display the delete button.     
  if(id == null || id == 0) return true;
  //For rows with id > 1 we need to be sure the user is allowed to delete 
  //FG - FOOF - After Cert - First Release Security - custom readings controlled by "managetemplates" 
  //return this.$hydrowareSecurityJS.canDelete_A('managecustomtasks');
  return this.$hydrowareSecurityJS.canDelete_A('managetemplates');
},




    getIntializedCustomTask() {
      return {
        'Id': 0,
        'Name': '',
        'Description': '',
        'IsCustom': true,
        'IsActive': true,
        'IsTask': true
      }
    },
    addSlotForNewLogCustomTask(position) {
      if(position=='top') {
        this.customTasks.unshift(this.getIntializedCustomTask());
      }
      else {
        this.customTasks.push(this.getIntializedCustomTask());
      }
    },
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    DeleteLogCustomTask(index, item) {
      let context = this
      var ID = item.Id
      var opts = {message: 'Are you sure you want to delete ' + item.Name + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteTaskRow.bind(null,ID,index))
    },
    deleteTaskRow(ID,index) {
      let context = this;
      if (ID == 0) { //Rows with an ID of zero have not yet been uploaded so they only need to be removed from the HTML Table
        context.customTasks.splice(index, 1)
        return
      }
      loader.startLoader()
      service.DeleteLogCustomTask(ID).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          loader.stopLoader()
          return;
        }

        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        context.customTasks.splice(index, 1)
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },
    /*
    DeleteLogCustomTask(index, item) {
      let context = this
      this.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        if (item.Id == 0) {
          context.customTasks.splice(index, 1)
          return
        }
        loader.startLoader()
        service.DeleteLogCustomTask(item.Id).then(function (response) {
          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })
          loader.stopLoader()
          context.customTasks.splice(index, 1)
        }, (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
      }).catch(() => {
      })
    },
    */
    AddAndUpdateLogCustomTasks() {
      let context = this
      loader.startLoader()
      service.AddAndUpdateLogCustomTasks(context.customTasks).then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          loader.stopLoader()
          return;
        }
        
        context.GetAllLogCustomTasks();//FG - FOOF - After Cert - First Release (6) - get the tasks so the id's are correct in the table
        context.$notify({
          title: 'Success',
          message: 'Tasks Updated',
          type: 'success'
        })
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    
    GetAllLogCustomTasks() {
      let context = this
      loader.startLoader()
      service.GetAllLogCustomTasks().then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          context.customTasks = []
          loader.stopLoader()
          return;
        }
        
        loader.stopLoader()
        if (response) {
          if (response.length > 0) {
            context.customTasks = response
          }
        } else {
          //context.customTasks = []
        }
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomTasks/custom_tasks.controller.js